import { render, staticRenderFns } from "./TwPortAndPlace.vue?vue&type=template&id=37d11385&"
import script from "./TwPortAndPlace.vue?vue&type=script&lang=js&"
export * from "./TwPortAndPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports